import { client } from '../http';
import DDLogs from '../DDLogs';

export default {
  sendCounter(counterName, tags) {
    client.post('/api/send-counter', { counterName, tags })
      .catch(err => DDLogs.error('Failed increasing metric', { err, metric: counterName, tags }));
  },
};
